import { render, staticRenderFns } from "./CustomerCallSheet.vue?vue&type=template&id=c94c95fa&scoped=true&"
import script from "./CustomerCallSheet.vue?vue&type=script&lang=ts&"
export * from "./CustomerCallSheet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94c95fa",
  null
  
)

export default component.exports